import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { VaRadio } from '@department-of-veterans-affairs/component-library/dist/react-bindings';

import recordEvent from 'platform/monitoring/record-event';

import { pageNames } from './pageList';
import {
  trackWizardStepView,
  trackWizardActiveDutySelection,
  trackWizardViewedWithInProgressForm,
} from '../../all-claims/utils/tracking/features/wizardTracking';

const label = 'Are you on active duty right now?';

const options = [
  { value: pageNames.bdd, label: 'Yes' },
  { value: pageNames.appeals, label: 'No' },
];

const StartPage = ({ setPageState, state = {} }) => {
  const savedForms = useSelector(s => s?.user?.profile?.savedForms || []);

  useEffect(() => {
    trackWizardStepView({ stepName: 'start' });
    trackWizardViewedWithInProgressForm({ savedForms });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onValueChange = ({ detail } = {}) => {
    const { value } = detail;
    if (value === state.selected) return;
    recordEvent({
      event: 'howToWizard-formChange',
      'form-field-type': 'form-radio-buttons',
      'form-field-label': label,
      'form-field-value': value === pageNames.bdd ? 'yes-bdd' : 'no-appeals',
    });
    trackWizardActiveDutySelection({ isActiveDuty: value === pageNames.bdd });
    setPageState({ selected: value }, value);
  };

  return (
    <VaRadio
      class="vads-u-margin-y--2"
      label={label}
      onVaValueChange={onValueChange}
    >
      {options.map(option => (
        <va-radio-option
          key={option.value}
          name="active-duty"
          label={option.label}
          value={option.value}
          checked={state.selected === option.value}
          aria-describedby={
            state.selected === option.value ? option.value : null
          }
        />
      ))}
    </VaRadio>
  );
};

export default {
  name: pageNames.start,
  component: StartPage,
};
